import state from './modulePromptState'
import actions from './modulePromptActions'
import getters from './modulePromptGetters'
import mutations from './modulePromptMutations'

export default {
    namespaced: true,
    isRegistered: false,

    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
}